import { render } from "./Navbar.vue?vue&type=template&id=54213b97"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=54213b97&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__